var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseDurationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.924805C3.65117 0.924805 0.125 4.45098 0.125 8.7998C0.125 13.1486 3.65117 16.6748 8 16.6748C12.3488 16.6748 15.875 13.1486 15.875 8.7998C15.875 4.45098 12.3488 0.924805 8 0.924805ZM11.1025 11.2203L10.5998 11.9059C10.5889 11.9208 10.5751 11.9334 10.5593 11.943C10.5434 11.9526 10.5259 11.9589 10.5076 11.9617C10.4893 11.9645 10.4706 11.9636 10.4527 11.9592C10.4347 11.9547 10.4178 11.9468 10.4029 11.9357L7.49551 9.81582C7.4774 9.80281 7.46267 9.78565 7.45258 9.76576C7.44248 9.74588 7.43731 9.72386 7.4375 9.70156V4.8623C7.4375 4.78496 7.50078 4.72168 7.57812 4.72168H8.42363C8.50098 4.72168 8.56426 4.78496 8.56426 4.8623V9.21289L11.0709 11.0252C11.1342 11.0691 11.1482 11.157 11.1025 11.2203Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseDurationIcon);
export default __webpack_public_path__ + "static/media/purchase-duration-icon.e2f268b99e023f4ce3782facf9115847.svg";
export { ForwardRef as ReactComponent };